import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';

const EVENTS = ['mousedown', 'mousemove', 'touchstart', 'keydown', 'scroll'];

// const IDLE_TIMOUT = 1000 * 20;
const IDLE_TIMOUT = 1000 * 60 * 15;

export default class InactivityWatcher extends PureComponent {
  state = { inactive: false };

  componentDidMount() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    if (!this.props.disabled) {
      this.enable();
    }
  }
  componentDidUpdate(prevProps) {
    if (!!prevProps.disabled !== !!this.props.disabled) {
      if (this.props.disabled) {
        this.disable();
      } else {
        this.enable();
      }
    }
  }
  componentWillUnmount() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    this.disable();
  }

  clearTimeout = () => {
    if (this.timeout) clearTimeout(this.timeout);
  };

  disable() {
    this.clearTimeout();
    this.removeListeners();
  }
  enable() {
    this.restartTimer();
  }

  removeListeners() {
    EVENTS.forEach(e => window.removeEventListener(e, this.restartTimer));
  }
  addListeners() {
    EVENTS.forEach(e => window.addEventListener(e, this.restartTimer));
  }

  // the fullscreen attain/release invokes the visibilitychange twice in succession.  Throttle to avoid unncessary action
  // ^^ this didn't work out, as the space between the visibilitychange events can be up to ~1 second (which is too long to throttle)
  // handleVisibilityChange = throttle(
  handleVisibilityChange = () => {
    if (!this.props.disabled) {
      // console.log('vis changed', document.visibilityState);
      if (document.hidden !== this.state.inactive) {
        document.hidden ? this.handleUserIdle() : this.handleUserActive();
      }
    }
  };
  //, 500, { leading: false });

  restartTimer = () => {
    this.clearTimeout();
    this.removeListeners();
    this.timeout = setTimeout(this.startListeningTimer, IDLE_TIMOUT * 0.4); // 15 mins
  };

  startListeningTimer = () => {
    this.clearTimeout();
    this.addListeners();
    this.timeout = setTimeout(this.handleUserIdle, IDLE_TIMOUT * 0.6);
  };

  handleUserIdle = () => {
    // console.log('user idle', Date.now());

    this.disable();
    this.props.onToggleInactive(true);
    this.setState({ inactive: true });
  };

  handleUserActive = () => {
    // console.log('user active', Date.now());

    this.enable();
    this.props.onToggleInactive(false);
    this.setState({ inactive: false });
  };

  render() {
    const { inactive } = this.state;

    return (
      <Dialog onClose={this.handleUserActive} open={inactive}>
        <DialogTitle>Are you still there?</DialogTitle>
        <DialogActions>
          <Button fullWidth onClick={this.handleUserActive} variant="contained">
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

InactivityWatcher.propTypes = {
  onToggleInactive: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};
